const DROPOFF_MARKER_PATH = "M0 -20C-3.87 -20 -7 -16.87 -7 -13c0 5.25 7 13 7 13s7 -7.75 7 -13c0 -3.87 -3.13 -7 -7 -7z";

export const CARRIER_MARKER_COLORS = {
    mercadolibre: "#ffe600",
    bluexpress: "#1976d2",
    chilexpress: "#d3a42f",
    starken: "#2e7d32",
    default: "#ff9800",
};

export const CANCELLED_MARKER_COLOR = "#e53935";

export const getCarrierMarkerColor = (carrier) => {
    if (!carrier) return CARRIER_MARKER_COLORS.default;
    return CARRIER_MARKER_COLORS[carrier] || CARRIER_MARKER_COLORS.default;
};

export const getDropoffMarkerStyle = ({ carrier, state, pointFactory } = {}) => {
    const fillColor = state === "cancelled"
        ? CANCELLED_MARKER_COLOR
        : getCarrierMarkerColor(carrier);

    return {
        path: DROPOFF_MARKER_PATH,
        fillColor,
        fillOpacity: 1,
        strokeColor: "#ffffff",
        strokeWeight: 3,
        scale: 1.8,
        ...(pointFactory ? { labelOrigin: pointFactory(0, -12) } : {}),
    };
};

export const DROPOFF_MARKER_STYLE = getDropoffMarkerStyle();

// Bandera a cuadros del cierre del viaje.
//
// Va como data URI y no como `path` —el mecanismo de los marcadores de dropoff de
// arriba— porque un Symbol de Google Maps tiene un solo `fillColor`, y lo que hace
// legible a esta bandera de un vistazo son justamente los cuadros: con un relleno
// plano queda un rectangulo sobre un palo, indistinguible de cualquier otro pin.
//
// Tampoco es un PNG en `map-markers/`: esos se sirven desde REACT_APP_IMAGES_PATH,
// que es un origen aparte del bundle, asi que sumar el archivo ahi es un paso de
// despliegue mas. Dibujada aca, viaja con el codigo.
export const FINISH_MARKER_COLOR = "#0d7f66";

const finishMarkerSvg = (color) => `
<svg xmlns="http://www.w3.org/2000/svg" width="34" height="46" viewBox="0 0 34 46">
  <g fill="none" fill-rule="evenodd">
    <path d="M9 41 L9 7" stroke="${color}" stroke-width="3.5" stroke-linecap="round"/>
    <circle cx="9" cy="41" r="3.5" fill="${color}"/>
    <rect x="9" y="6" width="19" height="14" fill="#ffffff"/>
    <rect x="9" y="6" width="9.5" height="7" fill="${color}"/>
    <rect x="18.5" y="13" width="9.5" height="7" fill="${color}"/>
    <rect x="9" y="6" width="19" height="14" stroke="${color}" stroke-width="2"/>
  </g>
</svg>`;

// `sizeFactory` y `pointFactory` se inyectan igual que en getDropoffMarkerStyle: este
// modulo no puede asumir que el SDK de Google ya cargo. Sin ellos el icono igual se
// dibuja, solo que anclado al centro en vez de a la base del palo.
export const getFinishMarkerIcon = ({ color = FINISH_MARKER_COLOR, sizeFactory, pointFactory } = {}) => ({
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(finishMarkerSvg(color).trim())}`,
    ...(sizeFactory ? { scaledSize: sizeFactory(34, 46) } : {}),
    // El ancla es la base del palo (9, 44), que es el punto que de verdad esta en esa
    // coordenada; centrarlo dejaria la bodega media cuadra mas arriba en el mapa.
    ...(pointFactory ? { anchor: pointFactory(9, 44) } : {}),
});
